<template>
  <div class="loading-container" v-if="loading">
    <loading></loading>
  </div>
  <div class="report-container" v-else>
    <div class="score_box">
      <div class="score_grade" v-if="contentInfo.grade"><span>{{contentInfo.grade}}级</span></div>
      <div class="star_box" v-if="contentInfo.grade">
        <img v-for="index in contentInfo.gradeLevel" :key="`y-${index}`" src="./images/star_y.png">
        <template v-if="(5 - contentInfo.gradeLevel) > 0">
          <img v-for="index in  (5 - contentInfo.gradeLevel)" :key="`w-${index}`" src="./images/star_w.png">
        </template>
      </div>
      <div class="yibiaopan">
        <div id="app1">
          <canvas id="canvas" width="200" height="200"></canvas>
          <p>-反欺诈规则-</p>
        </div>
        <div id="app2">
          <canvas id="canvas2" width="200" height="200"></canvas>
          <p>-反欺诈评分-</p>
        </div>
      </div>
      <!-- <p class="score_per">您的评分打败了全国<span id="total">{{defeatPercent}}%</span>的用户</p> -->
      <div class="jianyitg" v-if="contentInfo.finalDecision === 'ACCEPT'">
        <img src="./images/report_accept.png">
      </div>
      <div class="jianyitg" v-if="contentInfo.finalDecision === 'REJECT'">
        <img src="./images/report_reject.png">
      </div>
    </div>
    <p class="basic_info">
      <span>基本信息</span>
    </p>
    <div class="user_card">
      <p class="username">{{personalInfo.name}}&nbsp;&nbsp;{{personalInfo.age}}岁&nbsp;&nbsp;{{personalInfo.genderText}}</p>
      <div class="user_info">
        <p>
          <img src="./images/shoujihao.png" alt="">{{personalInfo.phoneNo}}
        </p>
      </div>
      <div class="user_info">
        <p>
          <img src="./images/shenfenzheng.png" alt="">{{personalInfo.certId}}
        </p>
        <p>
          <img src="./images/didian1.png" alt="">{{personalInfo.city}}
        </p>
      </div>
      <p class="init_time">报告生成时间：{{reportInfo.report_time}}</p>
      <p class="init_time">报告失效时间：{{reportInfo.invalidTime}}</p>
    </div>
    <p class="break_faith" v-if="bigRiskItems && bigRiskItems.length">
      <span>重要风险提示</span>
    </p>
    <div class="risk_box clearfix" v-if="bigRiskItems && bigRiskItems.length">
      <div class="risk_left">
        <ul>
          <li v-for="item in bigRiskItems" :key="`big-${item}`">{{item}}</li>
        </ul>
      </div>
      <div class="risk_right"></div>
    </div>
    <div class="quota_box" v-if="contentInfo.creditCardAmount">
      <div class="quota_item clearfix">
        <div class="quota_left">
          <p>信用卡预测额度</p>
          <p>{{contentInfo.creditCardAmount}}</p>
          <p class="tip">*触发机制：本笔贷款如期还款3-12期且复审评分达标</p>
        </div>
        <div class="quota_left">
          <p>贷款预审授信额度</p>
          <p>{{contentInfo.loanAmount}}</p>
        </div>
      </div>
    </div>
    <div class="plate_title" v-if="contentInfo.finalScore">
      <span class="circular circular1"></span>
      <span class="circular circular2"></span>
      <span class="circular circular3"></span>
      昊日五维综合评分
      <span class="circular circular3"></span>
      <span class="circular circular2"></span>
      <span class="circular circular1"></span>
    </div>
    <div class="intention_box" v-if="contentInfo.finalScore">
      <div class="intention_wrap">
        <div class="intention_score">
          <div class="score_bot">{{contentInfo.finalScore}}</div>
          <p class="intention_ti">评分取值范围[0-100]，分数越低，违约风险越高</p>
        </div>
      </div>
    </div>
    <p class="basic_info basic_info1" v-if="riskItems && riskItems.length">
      <span>反欺诈规则详情</span>
    </p>
    <div class="fqizhagz" v-if="riskItems && riskItems.length">
      <table border="" cellspacing="" cellpadding="">
        <tr>
          <th>命中规则详情</th>
          <th>取值结果</th>
        </tr>
        <tr v-for=" (item, index) in riskItems" :key="index">
          <td width="80%">{{item.description}}</td>
          <td width="20%">{{item.result}}</td>
        </tr>
      </table>
    </div>
    <p class="break_faith">
      <span>高风险命中查询</span>
    </p>
    <div class="search_id risk_hit">
      <p class="implement_ti">
        <span>消费及汽车金融类高风险</span>
      </p>
      <div class="risk_list">
        <p>
          消费金融负债偏高
          <span class="risk_yes" v-if="riskItemsMap.consumerFinance">是</span>
          <span v-else>否</span>
        </p>
      </div>
      <div class="risk_list">
        <p>
          汽车贷款风险名单
          <span class="risk_yes" v-if="riskItemsMap.carLeasing">是</span>
          <span v-else>否</span>
        </p>
      </div>
      <div class="risk_list">
        <p>
          汽车租赁违约
          <span class="risk_yes" v-if="riskItemsMap.carLeasing">是</span>
          <span v-else>否</span>
        </p>
      </div>
      <div class="risk_list">
        <p>
          故意违章乘车名单
          <span class="risk_yes" v-if="riskItemsMap.illegalTravel">是</span>
          <span v-else>否</span>
        </p>
      </div>
    </div>
    <div class="search_id risk_hit">
      <p class="implement_ti">
        <span>银行及法院类高风险</span>
      </p>
      <div class="risk_list">
        <p>
          负债率高，频繁申贷，职业异常
          <span class="risk_yes" v-if="riskItemsMap.loanApply">是</span>
          <span v-else>否</span>
        </p>
      </div>
      <div class="risk_list">
        <p>机构代办，异常审核<span>否</span></p>
      </div>
      <div class="risk_list">
        <p>当事人风险指数有增高倾向<span>否</span></p>
      </div>
      <div class="risk_list">
        <p>
          法院失信人
          <span class="risk_yes" v-if="riskItemsMap.courtFailure">是</span>
          <span v-else>否</span>
        </p>
      </div>
      <div class="risk_list">
        <p>
          法院执行人
          <span class="risk_yes" v-if="riskItemsMap.courtEnforcement">是</span>
          <span v-else>否</span>
        </p>
      </div>
      <div class="risk_list">
        <p>刑事犯罪风险<span>否</span></p>
      </div>
      <div class="risk_list">
        <p>
          欠税法人代表
          <span class="risk_yes" v-if="riskItemsMap.owingTaxes">是</span>
          <span v-else>否</span>
        </p>
      </div>
    </div>
    <div class="search_id risk_hit">
      <p class="implement_ti">
        <span>风险群体类高风险</span>
      </p>
      <div class="risk_list">
        <p>
          风险群体名单
          <span class="risk_yes" v-if="riskItemsMap.loanApply">是</span>
          <span v-else>否</span>
        </p>
        <p>风险类型：负债率高，频繁申贷，职业异常</p>
      </div>
      <div class="risk_list">
        <p>
          欺诈风险名单
          <span class="risk_yes" v-if="riskItemsMap.falseInformation">是</span>
          <span v-else>否</span>
        </p>
        <p>风险类型：仿冒风险，资料异常</p>
      </div>
      <div class="risk_list">
        <p>高负债名单<span>否</span></p>
        <p>风险类型：负债过高</p>
      </div>
      <div class="risk_list">
        <p>行业黑名单<span>否</span></p>
        <p>风险类型：从事行业风险过高</p>
      </div>
      <div class="risk_list">
        <p>
          羊毛党名单
          <span class="risk_yes" v-if="riskItemsMap.woolPeople">是</span>
          <span v-else>否</span>
        </p>
        <p>风险类型：恶意注册，刷单</p>
      </div>
      <div class="risk_list">
        <p>恶意注册名单<span>否</span></p>
        <p>风险类型：异常支付，异常注册</p>
      </div>
      <div class="risk_list">
        <p>身份证命中高风险区域<span>否</span></p>
        <p>风险类型：身份证所属地区逾期风险较集中</p>
      </div>
      <div class="risk_list">
        <p>归属地位于高风险集中地区<span>否</span></p>
        <p>风险类型：归属地区逾期属于高风险集中地区</p>
      </div>
    </div>
    <div class="search_id risk_hit">
      <p class="implement_ti">
        <span>信贷及逾期类高风险</span>
      </p>
      <div class="risk_list">
        <p>网络小贷高风险<span>否</span></p>
        <p>风险类型：异常支付，仿冒风险</p>
      </div>
      <div class="risk_list">
        <p>
          线下小贷高风险
          <span class="risk_yes" v-if="riskItemsMap.falseInformation">是</span>
          <span v-else>否</span>
        </p>
        <p>风险类型：机构代办，资料异常</p>
      </div>
      <div class="risk_list">
        <p>信贷逾期名单<span>否</span></p>
        <p>风险类型：逾期欠款</p>
      </div>
      <div class="risk_list">
        <p>信贷逾期后还款名单<span>否</span></p>
        <p>风险类型：从事行业风险过高</p>
      </div>
      <div class="risk_list">
        <p>网贷黑名单<span>否</span></p>
        <p>风险类型：信用异常</p>
      </div>
      <div class="risk_list">
        <p>
          网贷灰名单
          <span class="risk_yes" v-if="riskItemsMap.loanApply">是</span>
          <span v-else>否</span>
        </p>
        <p>风险类型：多头借款，有逾期倾向</p>
      </div>
      <div class="risk_list">
        <p>
          多头借贷严重名单
          <span class="risk_yes" v-if="riskItemsMap.loanApply">是</span>
          <span v-else>否</span>
        </p>
        <p>风险类型：频繁注册申请贷款</p>
      </div>
      <div class="risk_list">
        <p>存在信用逾期历史记录<span>否</span></p>
        <p>风险类型：逾期，逾期后还款</p>
      </div>
      <div class="risk_list">
        <p>助学贷款欠费历史<span>否</span></p>
        <p>风险类型：助学贷款欠费逾期</p>
      </div>
    </div>
    <p class="basic_info basic_info1">
      <span>身份证多头借贷数据</span>
    </p>
    <div class="search_id apply_num clearfix id_app_count">
      <p class="apply_tit">银行类机构申请次数汇总(次)</p>
      <div class="apply_list" v-for="item in idAppCounts.bank" :key="`id-bank-${item.title}`">
        <p class="apply_left">{{item.value}}</p>
        <p class="apply_right">{{item.title}}</p>
      </div>
      <div class="clearfix"></div>
      <p class="apply_tit apply_tit1">非银行类机构申请次数汇总(次)</p>
      <div class="apply_list" v-for="item in idAppCounts.nonBank" :key="`id-nonBank-${item.title}`">
        <p class="apply_left">{{item.value}}</p>
        <p class="apply_right">{{item.title}}</p>
      </div>
    </div>
    <div class="search_id loan_box">
      <p class="loan_tob clearfix">
        <span @click="onChangeDay('i', 'day7')" :class="{active: iActiveLoanInfo === 'day7'}">近7天</span>
        <span @click="onChangeDay('i', 'day30')" :class="{active: iActiveLoanInfo === 'day30'}">近1个月</span>
        <span @click="onChangeDay('i', 'day90')" :class="{active: iActiveLoanInfo === 'day90'}">近3个月</span>
      </p>
      <div class="loan_tab clearfix">
        <div class="loan_item active">
          <div class="loan_list loan_listh">
            <p class="loan_list_left">银行类</p>
            <p class="loan_list_right"></p>
          </div>
          <div class="loan_list" v-for="(item, key) of personalBankLoanInfo" :key="`bank-${key}`">
            <p class="loan_list_left">{{item.title}}</p>
            <p class="loan_list_right">
              <span class="loan_tell">{{item.i[iActiveLoanInfo]}}</span>
            </p>
          </div>
          <div class="loan_list loan_listh">
            <p class="loan_list_left">非银行类</p>
            <p class="loan_list_right"></p>
          </div>
          <div class="loan_list" v-for="(item, key) of personalLoanInfo" :key="`loan-${key}`">
            <p class="loan_list_left">{{item.title}}</p>
            <p class="loan_list_right">
              <span class="loan_tell">{{item.i[iActiveLoanInfo]}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <p class="break_faith">
      <span>手机号多头借贷数据</span>
    </p>
    <div class="search_id apply_num apply_nums clearfix id_app_count">
      <p class="apply_tit">银行类机构申请次数汇总(次)</p>
      <div class="apply_list" v-for="item in mobileAppCounts.bank" :key="`id-tenant-bank-${item.title}`">
        <p class="apply_left">{{item.value}}</p>
        <p class="apply_right">{{item.title}}</p>
      </div>
      <div class="clearfix"></div>
      <p class="apply_tit apply_tit1">非银行类机构申请次数汇总(次)</p>
      <div class="apply_list" v-for="item in mobileAppCounts.nonBank" :key="`id-tenant-nonBank-${item.title}`">
        <p class="apply_left">{{item.value}}</p>
        <p class="apply_right">{{item.title}}</p>
      </div>
    </div>
    <div class="search_id loan_box">
      <p class="loan_tob loan_tob1 clearfix">
        <span @click="onChangeDay('m', 'day7')" :class="{active: mActiveLoanInfo === 'day7'}">近7天</span>
        <span @click="onChangeDay('m', 'day30')" :class="{active: mActiveLoanInfo === 'day30'}">近1个月</span>
        <span @click="onChangeDay('m', 'day90')" :class="{active: mActiveLoanInfo === 'day90'}">近3个月</span>
      </p>
      <div class="loan_tab clearfix">
        <div class="loan_item active">
          <div class="loan_list loan_listh">
            <p class="loan_list_left">银行类</p>
            <p class="loan_list_right"></p>
          </div>
          <div class="loan_list" v-for="(item, key) of personalBankLoanInfo" :key="key">
            <p class="loan_list_left">{{item.title}}</p>
            <p class="loan_list_right">
              <span class="loan_tell">{{item.m[iActiveLoanInfo]}}</span>
            </p>
          </div>
          <div class="loan_list loan_listh">
            <p class="loan_list_left">非银行类</p>
            <p class="loan_list_right"></p>
          </div>
          <div class="loan_list" v-for="(item, key) of personalLoanInfo" :key="key">
            <p class="loan_list_left">{{item.title}}</p>
            <p class="loan_list_right">
              <span class="loan_tell">{{item.m[iActiveLoanInfo]}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bus_type bustype1">
      <p class="bus_ti">关联机构类型详情</p>
      <table border="1">
        <tbody>
          <tr>
            <td></td>
            <td>近15天</td>
            <td>近1个月</td>
            <td>近3个月</td>
            <td>近6个月</td>
            <td>近12个月</td>
          </tr>
          <tr>
            <td>信用卡(类信用卡)</td>
            <td>0</td>
            <td>0</td>
            <td>2</td>
            <td>3</td>
            <td>5</td>
          </tr>
        </tbody>
      </table>
    </div> -->
    <!-- <p class="basic_info basic_info1">
      <span>多头借贷异常时间段</span>
    </p>
    <div class="bus_type">
      <p class="bus_ti">次数</p>
      <table border="1">
        <tbody>
          <tr>
            <td></td>
            <td>近15天</td>
            <td>近1个月</td>
            <td>近3个月</td>
            <td>近6个月</td>
            <td>近12个月</td>
          </tr>
          <tr>
            <td>夜间-银行</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>夜间-非银</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>周末-银行</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>周末-非银</td>
            <td>0</td>
            <td>0</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="bus_type">
      <p class="bus_ti">机构数</p>
      <table border="1">
        <tbody>
          <tr>
            <td></td>
            <td>近15天</td>
            <td>近1个月</td>
            <td>近3个月</td>
            <td>近6个月</td>
            <td>近12个月</td>
          </tr>
          <tr>
            <td>夜间-银行</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>夜间-非银</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>周末-银行</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>周末-非银</td>
            <td>0</td>
            <td>0</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
          </tr>
        </tbody>
      </table>
    </div> -->
    <p class="basic_info basic_info1">
      <span>黑名单风险监测</span>
    </p>
    <div class="bus_type">
      <table border="1">
        <tbody>
          <tr>
            <td></td>
            <td>设备ID</td>
            <td>家庭地址</td>
            <td>座机号</td>
            <td>手机号</td>
            <td>身份证</td>
          </tr>
          <tr>
            <td>黑名单等级</td>
            <td>{{blackData.deviceId[0]}}</td>
            <td>{{blackData.homeAddress[0]}}</td>
            <td>{{blackData.homePhone[0]}}</td>
            <td>{{blackData.mobile[0]}}</td>
            <td>{{blackData.id[0]}}</td>
          </tr>
          <tr>
            <td>黑名单的机构数</td>
            <td>{{blackData.deviceId[1]}}</td>
            <td>{{blackData.homeAddress[1]}}</td>
            <td>{{blackData.homePhone[1]}}</td>
            <td>{{blackData.mobile[1]}}</td>
            <td>{{blackData.id[1]}}</td>
          </tr>
          <tr>
            <td>申请查询数</td>
            <td>{{blackData.deviceId[2]}}</td>
            <td>{{blackData.homeAddress[2]}}</td>
            <td>{{blackData.homePhone[2]}}</td>
            <td>{{blackData.mobile[2]}}</td>
            <td>{{blackData.id[2]}}</td>
          </tr>
          <tr>
            <td>入库距离天数</td>
            <td>{{blackData.deviceId[3]}}</td>
            <td>{{blackData.homeAddress[3]}}</td>
            <td>{{blackData.homePhone[3]}}</td>
            <td>{{blackData.mobile[3]}}</td>
            <td>{{blackData.id[3]}}</td>
          </tr>
          <tr>
            <td>欺诈/逾期状态</td>
            <td>{{blackData.deviceId[4]}}</td>
            <td>{{blackData.homeAddress[4]}}</td>
            <td>{{blackData.homePhone[4]}}</td>
            <td>{{blackData.mobile[4]}}</td>
            <td>{{blackData.id[4]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div class="search_id historical">
      <div class="loan_list loan_list1">
        <p class="loan_list_left">直接联系人黑名单人数</p>
        <p class="loan_list_right">
          <span class="loan_tell">2人</span>
        </p>
      </div>
      <div class="loan_list loan_list1">
        <p class="loan_list_left">间接联系人黑名单人数 </p>
        <p class="loan_list_right">
          <span class="loan_tell">10人</span>
        </p>
      </div>
    </div> -->
    <!-- <p class="basic_info basic_info1">
      <span>失信情况总览</span>
    </p>
    <div class="implement_box">
      <p class="implement_ti">
        <span>失信被执行人</span>
      </p>
      <p class="implement_info">
        <span>李四</span>
        <span>绵阳市</span>
        <span>47154********5478</span>
      </p>
      <p class="implement_item">
        <span class="info_left">执行案号：</span>
        <span class="info_right">（2016）安执字第00175号</span>
      </p>
      <p class="implement_item">
        <span class="info_left">执行标的：</span>
        <span class="info_right">20000</span>
      </p>
      <p class="implement_item">
        <span class="info_left">立案时间：</span>
        <span class="info_right">2016年04月05日</span>
      </p>
      <p class="implement_item">
        <span class="info_left">发布时间：</span>
        <span class="info_right">2016年08月19日</span>
      </p>
      <p class="implement_item">
        <span class="info_left">执行法院：</span>
        <span class="info_right">游仙区人民法院</span>
      </p>
      <p class="implement_item">
        <span class="info_left">做出执行依据单位：</span>
        <span class="info_right">游仙区人民法院</span>
      </p>
      <p class="implement_item">
        <span class="info_left">失信案件执行依据文号:</span>
        <span class="info_right">（2018）安执字第00175号</span>
      </p>
      <p class="implement_item">
        <span class="info_left">被执行人的履行情况：</span>
        <span class="info_right">全部未履行</span>
      </p>
      <p class="implement_item">
        <span class="info_left">生效法律文书确定的义务：</span>
        <span class="info_right">其他有履行能力而拒不履<br>行生效法律文书确定义务</span>
      </p>
      <p class="implement_item">
        <span class="info_left">失信被执行人行为具体情形：</span>
        <span class="info_right">其他有履行能力而拒不履<br>行生效法律文书确定义务</span>
      </p>
    </div>
    <div class="implement_box">
      <p class="implement_ti">
        <span>法院被执行人</span>
      </p>
      <p class="implement_info">
        <span>李四</span>
        <span>绵阳市</span>
        <span>47154********5478</span>
      </p>
      <p class="implement_item">
        <span class="info_left">执行案号：</span>
        <span class="info_right">（2016）安执字第00175号</span>
      </p>
      <p class="implement_item">
        <span class="info_left">执行标的：</span>
        <span class="info_right">20000</span>
      </p>
      <p class="implement_item">
        <span class="info_left">立案时间：</span>
        <span class="info_right">2016年04月05日</span>
      </p>
      <p class="implement_item">
        <span class="info_left">执行法院：</span>
        <span class="info_right">游仙区人民法院</span>
      </p>
      <p class="implement_item">
        <span class="info_left">案件状态：</span>
        <span class="info_right">执行中</span>
      </p>
      <div class="horizontal_line"></div>
      <p class="implement_info">
        <span>李四</span>
        <span>绵阳市</span>
        <span>47154********5478</span>
      </p>
      <p class="implement_item">
        <span class="info_left">执行案号：</span>
        <span class="info_right">（2016）安执字第00175号</span>
      </p>
      <p class="implement_item">
        <span class="info_left">执行标的：</span>
        <span class="info_right">20000</span>
      </p>
      <p class="implement_item">
        <span class="info_left">立案时间：</span>
        <span class="info_right">2016年04月05日</span>
      </p>
      <p class="implement_item">
        <span class="info_left">执行法院：</span>
        <span class="info_right">游仙区人民法院</span>
      </p>
      <p class="implement_item">
        <span class="info_left">案件状态：</span>
        <span class="info_right">终结本次程序</span>
      </p>
    </div> -->
    <p class="break_faith" v-if="contentInfo.approvalOpinion">
      <span>审批意见</span>
    </p>
    <div class="spyj" v-if="contentInfo.approvalOpinion">{{contentInfo.approvalOpinion}}</div>
    <div class="plate_title">
      <span class="circular circular1"></span>
      <span class="circular circular2"></span>
      <span class="circular circular3"></span>
      宙斯盾中高风险扣分项
      <span class="circular circular3"></span>
      <span class="circular circular2"></span>
      <span class="circular circular1"></span>
    </div>
    <div class="search_id propose_box">
      <p>1.被执行记录</p>
      <p>2.三个月注册申请超过五次</p>
      <p>3.一年内有贷款或信用卡逾期</p>
      <p>4.有司法纠纷中</p>
      <p>5.半年内信用卡申请超过六次</p>
      <p>6.相同机构多次申请</p>
      <p>7.紧急联系人命中黑名单</p>
      <p>8.提交申请时定位处于深度风险位置</p>
      <p>9.申请人非实名制手机号</p>
      <p>10.预留紧急联系人未命中频繁联系或关联</p>
      <p>11.紧急联系人命中不良</p>
      <p>12.紧急联系人手机号码非实名本人</p>
      <p>13.涉及信用卡违规套现</p>
    </div>
    <div class="plate_title">
      <span class="circular circular1"></span>
      <span class="circular circular2"></span>
      <span class="circular circular3"></span>
      昊日五维评分体系
      <span class="circular circular3"></span>
      <span class="circular circular2"></span>
      <span class="circular circular1"></span>
    </div>
    <div class="search_id propose_box">
      <p>1.人脉综合</p>
      <p>2.行为特质综合</p>
      <p>3.资产负债现金流综合</p>
      <p>4.身份特质综合</p>
      <p>5.守约历史综合</p>
    </div>
    <div class="bot_box">
      <p class="bot_title">宙斯盾审批系统说明</p>
      <p class="data_txt">数据来源包括各大征信系统，各大运营商，各大贷款平台，宙斯盾系统只做大数据信息的获取和分析。特别说明：审批报告不做保存，仅限本次风控审批使用。</p>
      <!-- <img class="go_top" src="./images/fanhuidingbu.png" alt=""> -->
    </div>
  </div>
</template>
<script>
import Gauge from './Gauge'
import { CityArray } from '@/constants'
import { getReportData } from '@/services/ReportService'
import Loading from '@/components/Loading'

export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      finalScore: 0,
      defeatPercent: 0,
      reportInfo: {},
      personalInfo: {},
      contentInfo: {},
      bigRiskItems: [],
      idAppCounts: {
        bank: [],
        nonBank: [],
        other: []
      },
      mobileAppCounts: {
        bank: [],
        nonBank: [],
        other: []
      },
      idTenantCounts: {
        bank: [],
        nonBank: [],
        other: []
      },
      mobileTenantCounts: {
        bank: [],
        nonBank: [],
        other: []
      },
      personalBankLoanInfo: {
        DirBank: {
          title: '直销银行',
          type: 'bank',
          i: {},
          m: {}
        },
        LarBank: {
          title: '大型商业银行',
          type: 'bank',
          i: {},
          m: {}
        },
        PriBank: {
          title: '民营银行',
          type: 'bank',
          i: {},
          m: {}
        },
        RurCombank: {
          title: '农商银行',
          type: 'bank',
          i: {},
          m: {}
        },
        RurCrecoop: {
          title: '农信社',
          type: 'bank',
          i: {},
          m: {}
        },
        StoBank: {
          title: '股份制商业银行',
          type: 'bank',
          i: {},
          m: {}
        },
        UrbBank: {
          title: '城市商业银行',
          type: 'bank',
          i: {},
          m: {}
        },
        VilBank: {
          title: '村镇银行',
          type: 'bank',
          i: {},
          m: {}
        }
      },
      personalLoanInfo: {
        AutoDealer: {
          title: '汽车经销商',
          type: 'noBank',
          i: {},
          m: {}
        },
        AutoLease: {
          title: '车辆类经营租赁公司',
          type: 'noBank',
          i: {},
          m: {}
        },
        Consumfin: {
          title: '消费金融',
          type: 'noBank',
          i: {},
          m: {}
        },
        DraPlat: {
          title: '引流平台',
          type: 'noBank',
          i: {},
          m: {}
        },
        GeConsum: {
          title: '一般消费平台',
          type: 'noBank',
          i: {},
          m: {}
        },
        LoanAssistPlat: {
          title: '助贷服务平台',
          type: 'noBank',
          i: {},
          m: {}
        },
        OtherCom: {
          title: '其他公司',
          type: 'noBank',
          i: {},
          m: {}
        },
        SmallLoan: {
          title: '小额贷款公司',
          type: 'noBank',
          i: {},
          m: {}
        }
      },
      iActiveLoanInfo: 'day90',
      mActiveLoanInfo: 'day90',
      blackData: {
        deviceId: [],
        homeAddress: [],
        homePhone: [],
        mobile: [],
        id: []
      },
      riskItems: [],
      riskItemsMap: {}
    }
  },
  async mounted() {
    await this._initReportDetail()
    this._initGauge()
  },
  methods: {
    onChangeDay(type, day) {
      if (type === 'i') {
        this.iActiveLoanInfo = day
      } else {
        this.mActiveLoanInfo = day
      }
    },
    _initGauge() {
      const canvas1 = document.getElementById('canvas')
      const gauge1 = new Gauge({
        canvas: canvas1
      })
      gauge1.render()
      setTimeout(() => {
        gauge1.update(this.reportInfo.antiRule)
      }, 10)

      const canvas2 = document.getElementById('canvas2')
      const gauge2 = new Gauge({
        canvas: canvas2
      })
      gauge2.render()
      setTimeout(() => {
        gauge2.update(this.reportInfo.antiScore)
      }, 10)
    },
    async _initReportDetail() {
      const openId = localStorage.getItem('openId')
      const { orderId } = this.$route.query
      this.loading = true
      const response = await getReportData({
        openId,
        orderId
      })
      this.loading = false
      this.reportInfo = response.data.report
      this.finalScore = Number(this.reportInfo.final_score)
      this.defeatPercent = (100 - this.finalScore / 14).toFixed(2)
      this.contentInfo = this.reportInfo.contentJson || {}
      this.contentInfo.gradeLevel = 5 - 'ABCDE'.indexOf(this.contentInfo.grade)
      this._normalizeData(response.data)
    },
    _normalizeData(data) {
      this._normalizePersonalInfo(data)
      this._normalizeBigRiskItems(data)
      this._normalizeIdAppCounts(data)
      this._normalizeMobileAppCounts(data)
      this._normalizeIdTenantCounts(data)
      this._normalizeMobileTenantCounts(data)
      this._normalizePersonalLoanInfo(data)
      this._normalizeBlackData(data)
      this._normalizeRiskItems(data)
    },
    _normalizePersonalInfo(data) {
      const { name, age, gender, phoneNo, certId } = data
      this.personalInfo = {
        name,
        age,
        gender,
        genderText: gender === 1 ? '男' : '女',
        phoneNo,
        certId,
        city: CityArray[parseInt(certId.substr(0, 2))]
      }
    },
    _normalizeBigRiskItems(data) {
      const riskNames = data.report.risk_items.map((item) => item.risk_name)
      const indicatrixes = data.report.output_indicatrixes
      const bigRiskItems = []
      riskNames.forEach((name) => {
        if (name.includes('法院失信')) {
          if (!bigRiskItems.includes('法院失信名单')) {
            bigRiskItems.push('法院失信名单')
          }
        }
        if (name.includes('法院执行')) {
          if (!bigRiskItems.includes('法院执行名单')) {
            bigRiskItems.push('法院执行名单')
          }
        }
        if (name.includes('欠税')) {
          if (!bigRiskItems.includes('欠税名单')) {
            bigRiskItems.push('欠税名单')
          }
        }
        if (name.includes('违规出行')) {
          if (!bigRiskItems.includes('违规出行名单')) {
            bigRiskItems.push('违规出行名单')
          }
        }
        if (name.includes('车辆租赁违约')) {
          if (!bigRiskItems.includes('车辆租赁违约名单')) {
            bigRiskItems.push('车辆租赁违约名单')
          }
        }
        if (name.includes('多头')) {
          if (!bigRiskItems.includes('多头借贷严重名单')) {
            bigRiskItems.push('多头借贷严重名单')
          }
        }
        if (name.includes('非银金融')) {
          if (!bigRiskItems.includes('网络小贷高风险名单')) {
            bigRiskItems.push('网络小贷高风险名单')
          }
        }
        if (name.includes('高风险')) {
          if (!bigRiskItems.includes('风险群体名单')) {
            bigRiskItems.push('风险群体名单')
          }
        }
      })
      if (indicatrixes && indicatrixes.m_cnt_wool_Gen_Gen_90day > 0) {
        bigRiskItems.push('羊毛党名单')
      }
      this.bigRiskItems = bigRiskItems
    },
    _normalizeIdAppCounts(data) {
      const idData = data.report.vcExternalsData.pid || {}
      this.idAppCounts = {
        bank: [
          {
            title: '近7天',
            value: this._filterCount(
              ((idData.D7 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((idData.D30 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((idData.D90 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((idData.D180 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((idData.D360 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((idData.D540 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((idData.D720 || {}).Banks || {}).totalAppsNumber
            )
          }
        ],
        nonBank: [
          {
            title: '近7天',
            value: this._filterCount(
              ((idData.D7 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((idData.D30 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((idData.D90 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((idData.D180 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((idData.D360 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((idData.D540 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((idData.D720 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          }
        ],
        other: [
          {
            title: '近7天',
            value: this._filterCount(
              ((idData.D7 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((idData.D30 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((idData.D90 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((idData.D180 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((idData.D360 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((idData.D540 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((idData.D720 || {}).Others || {}).totalAppsNumber
            )
          }
        ]
      }
    },
    _normalizeMobileAppCounts(data) {
      const mobileData = data.report.vcExternalsData.mobile || {}
      this.mobileAppCounts = {
        bank: [
          {
            title: '近7天',
            value: this._filterCount(
              ((mobileData.D7 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((mobileData.D30 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((mobileData.D90 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((mobileData.D180 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((mobileData.D360 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((mobileData.D540 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((mobileData.D720 || {}).Banks || {}).totalAppsNumber
            )
          }
        ],
        nonBank: [
          {
            title: '近7天',
            value: this._filterCount(
              ((mobileData.D7 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((mobileData.D30 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((mobileData.D90 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((mobileData.D180 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((mobileData.D360 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((mobileData.D540 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((mobileData.D720 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          }
        ],
        other: [
          {
            title: '近7天',
            value: this._filterCount(
              ((mobileData.D7 || 0).Others || 0).totalAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((mobileData.D30 || 0).Others || 0).totalAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((mobileData.D90 || 0).Others || 0).totalAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((mobileData.D180 || 0).Others || 0).totalAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((mobileData.D360 || 0).Others || 0).totalAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((mobileData.D540 || 0).Others || 0).totalAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((mobileData.D720 || 0).Others || 0).totalAppsNumber
            )
          }
        ]
      }
    },
    _normalizeIdTenantCounts(data) {
      const idData = data.report.vcExternalsData.pid || {}
      this.idTenantCounts = {
        bank: [
          {
            title: '近7天',
            value: this._filterCount(
              ((idData.D7 || {}).Banks || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((idData.D30 || {}).Banks || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((idData.D90 || {}).Banks || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((idData.D180 || {}).Banks || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((idData.D360 || {}).Banks || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((idData.D540 || {}).Banks || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((idData.D720 || {}).Banks || {}).crossTenantAppsNumber
            )
          }
        ],
        nonBank: [
          {
            title: '近7天',
            value: this._filterCount(
              ((idData.D7 || {})['Non-bankFin'] || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((idData.D30 || {})['Non-bankFin'] || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((idData.D90 || {})['Non-bankFin'] || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((idData.D180 || {})['Non-bankFin'] || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((idData.D360 || {})['Non-bankFin'] || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((idData.D540 || {})['Non-bankFin'] || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((idData.D720 || {})['Non-bankFin'] || {}).crossTenantAppsNumber
            )
          }
        ],
        other: [
          {
            title: '近7天',
            value: this._filterCount(
              ((idData.D7 || {}).Others || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((idData.D30 || {}).Others || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((idData.D90 || {}).Others || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((idData.D180 || {}).Others || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((idData.D360 || {}).Others || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((idData.D540 || {}).Others || {}).crossTenantAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((idData.D720 || {}).Others || {}).crossTenantAppsNumber
            )
          }
        ]
      }
    },
    _normalizeMobileTenantCounts(data) {
      const mobileData = data.report.vcExternalsData.mobile || {}
      this.mobileTenantCounts = {
        bank: [
          {
            title: '近7天',
            value: this._filterCount(
              ((mobileData.D7 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((mobileData.D30 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((mobileData.D90 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((mobileData.D180 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((mobileData.D360 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((mobileData.D540 || {}).Banks || {}).totalAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((mobileData.D720 || {}).Banks || {}).totalAppsNumber
            )
          }
        ],
        nonBank: [
          {
            title: '近7天',
            value: this._filterCount(
              ((mobileData.D7 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((mobileData.D30 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((mobileData.D90 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((mobileData.D180 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((mobileData.D360 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((mobileData.D540 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((mobileData.D720 || {})['Non-bankFin'] || {}).totalAppsNumber
            )
          }
        ],
        other: [
          {
            title: '近7天',
            value: this._filterCount(
              ((mobileData.D7 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近30天',
            value: this._filterCount(
              ((mobileData.D30 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近90天',
            value: this._filterCount(
              ((mobileData.D90 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近180天',
            value: this._filterCount(
              ((mobileData.D180 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近360天',
            value: this._filterCount(
              ((mobileData.D360 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近540天',
            value: this._filterCount(
              ((mobileData.D540 || {}).Others || {}).totalAppsNumber
            )
          },
          {
            title: '近720天',
            value: this._filterCount(
              ((mobileData.D720 || {}).Others || {}).totalAppsNumber
            )
          }
        ]
      }
    },
    _normalizePersonalLoanInfo(data) {
      const personalLoanInfoData = data.report.personaspreloanIndicatrix
      const _assembleLoanInfo = (key, loanInfo, type) => {
        const dataMap = {
          bank: 'personalBankLoanInfo',
          noBank: 'personalLoanInfo'
        }
        if (loanInfo.hasOwnProperty(`i_cnt_partner_v3_Loan_${key}_7day`)) {
          this[dataMap[type]][key].i.day7 = this._filterCount(
            loanInfo[`i_cnt_partner_v3_Loan_${key}_7day`]
          )
        }
        if (loanInfo.hasOwnProperty(`i_cnt_partner_v3_Loan_${key}_30day`)) {
          this[dataMap[type]][key].i.day30 = this._filterCount(
            loanInfo[`i_cnt_partner_v3_Loan_${key}_30day`]
          )
        }
        if (loanInfo.hasOwnProperty(`i_cnt_partner_v3_Loan_${key}_90day`)) {
          this[dataMap[type]][key].i.day90 = this._filterCount(
            loanInfo[`i_cnt_partner_v3_Loan_${key}_90day`]
          )
        }
        if (loanInfo.hasOwnProperty(`m_cnt_partner_v3_Loan_${key}_7day`)) {
          this[dataMap[type]][key].m.day7 = this._filterCount(
            loanInfo[`m_cnt_partner_v3_Loan_${key}_7day`]
          )
        }
        if (loanInfo.hasOwnProperty(`m_cnt_partner_v3_Loan_${key}_30day`)) {
          this[dataMap[type]][key].m.day30 = this._filterCount(
            loanInfo[`m_cnt_partner_v3_Loan_${key}_30day`]
          )
        }
        if (loanInfo.hasOwnProperty(`m_cnt_partner_v3_Loan_${key}_90day`)) {
          this[dataMap[type]][key].m.day90 = this._filterCount(
            loanInfo[`m_cnt_partner_v3_Loan_${key}_90day`]
          )
        }
      }

      personalLoanInfoData.forEach((loanInfo) => {
        _assembleLoanInfo('AutoDealer', loanInfo, 'noBank')
        _assembleLoanInfo('AutoLease', loanInfo, 'noBank')
        _assembleLoanInfo('Consumfin', loanInfo, 'noBank')
        _assembleLoanInfo('DirBank', loanInfo, 'bank')
        _assembleLoanInfo('DraPlat', loanInfo, 'noBank')
        _assembleLoanInfo('GeConsum', loanInfo, 'noBank')
        _assembleLoanInfo('LarBank', loanInfo, 'bank')
        _assembleLoanInfo('LoanAssistPlat', loanInfo, 'noBank')
        _assembleLoanInfo('OtherCom', loanInfo, 'noBank')
        _assembleLoanInfo('PriBank', loanInfo, 'bank')
        _assembleLoanInfo('RurCombank', loanInfo, 'bank')
        _assembleLoanInfo('RurCrecoop', loanInfo, 'bank')
        _assembleLoanInfo('SmallLoan', loanInfo, 'noBank')
        _assembleLoanInfo('StoBank', loanInfo, 'bank')
        _assembleLoanInfo('UrbBank', loanInfo, 'bank')
        _assembleLoanInfo('VilBank', loanInfo, 'bank')
      })
    },
    _normalizeBlackData(data) {
      const blackData = (data.report.blacklistData || {}).blacklist || {}
      const filterNumber = (num) => {
        return num < 0 ? 0 : num
      }
      const filterLevel = (type) => {
        return type === 'fraud' ? '欺诈' : '/'
      }
      const filterStatus = (type) => {
        return type === 'DLQ90plus'
          ? '严重逾期'
          : type === 'DLQX'
          ? '早期逾期'
          : '/'
      }
      this.blackData.deviceId = [
        filterLevel((blackData.deviceId || {}).blackLevel),
        filterNumber((blackData.deviceId || {}).last6MTenantCount),
        filterNumber((blackData.deviceId || {}).last6MQueryCount),
        filterNumber((blackData.deviceId || {}).lastConfirmAtDays),
        filterStatus((blackData.deviceId || {}).lastConfirmStatus)
      ]
      this.blackData.homeAddress = [
        filterLevel((blackData.home_address || {}).blackLevel),
        filterNumber((blackData.home_address || {}).last6MTenantCount),
        filterNumber((blackData.home_address || {}).last6MQueryCount),
        filterNumber((blackData.home_address || {}).lastConfirmAtDays),
        filterStatus((blackData.home_address || {}).lastConfirmStatus)
      ]
      this.blackData.homePhone = [
        filterLevel((blackData.home_phone || {}).blackLevel),
        filterNumber((blackData.home_phone || {}).last6MTenantCount),
        filterNumber((blackData.home_phone || {}).last6MQueryCount),
        filterNumber((blackData.home_phone || {}).lastConfirmAtDays),
        filterStatus((blackData.home_phone || {}).lastConfirmStatus)
      ]
      this.blackData.mobile = [
        filterLevel((blackData.mobile || {}).blackLevel),
        filterNumber((blackData.mobile || {}).last6MTenantCount),
        filterNumber((blackData.mobile || {}).last6MQueryCount),
        filterNumber((blackData.mobile || {}).lastConfirmAtDays),
        filterStatus((blackData.mobile || {}).lastConfirmStatus)
      ]
      this.blackData.id = [
        filterLevel((blackData.pid || {}).blackLevel),
        filterNumber((blackData.pid || {}).last6MTenantCount),
        filterNumber((blackData.pid || {}).last6MQueryCount),
        filterNumber((blackData.pid || {}).lastConfirmAtDays),
        filterStatus((blackData.pid || {}).lastConfirmStatus)
      ]
    },
    _normalizeRiskItems(data) {
      const riskItems = data.report.risk_items.filter(
        (item) => !!item.risk_detail
      )
      const riskData = []
      const indicatrixes = data.report.output_indicatrixes
      if (indicatrixes && indicatrixes.m_cnt_wool_Gen_Gen_90day > 0) {
        this.riskItemsMap.woolPeople = true
      }
      if (riskItems && riskItems.length) {
        riskItems.forEach((item) => {
          if (item.risk_name.includes('消费金融')) {
            this.riskItemsMap.consumerFinance = true
          }
          if (item.risk_name.includes('车辆租赁')) {
            this.riskItemsMap.financeLeasing = true
            this.riskItemsMap.carLeasing = true
          }
          if (item.risk_name.includes('违规出行')) {
            this.riskItemsMap.illegalTravel = true
          }
          if (item.risk_name.includes('申请借款')) {
            this.riskItemsMap.loanApply = true
          }
          if (item.risk_name.includes('法院失信')) {
            this.riskItemsMap.courtFailure = true
          }
          if (item.risk_name.includes('法院执行')) {
            this.riskItemsMap.courtEnforcement = true
          }
          if (item.risk_name.includes('欠税')) {
            this.riskItemsMap.owingTaxes = true
          }
          if (item.risk_name.includes('虚假')) {
            this.riskItemsMap.falseInformation = true
          }
          if (item.risk_detail && item.risk_detail.length) {
            item.risk_detail.forEach((detail) => {
              const detailList = detail.indicatrix_result_detail_list
              if (detailList && detailList.length) {
                detailList.forEach((d) => {
                  riskData.push(d)
                })
              }
            })
          }
        })
      }
      this.riskItems = riskData
    },
    _filterCount(count) {
      if (count < 0) {
        return 0
      }
      return count || 0
    }
  }
}
</script>
<style scoped src="./index.css"></style>
